import Alpine from 'alpinejs'

Alpine.data('imageObject', () => ({
  img: null as HTMLImageElement | null,
  isLoaded: false,

  init() {
    this.img = this.$el.querySelector('.media-container') as HTMLImageElement

    if (this.img?.complete) this.isLoaded = true

    this.img?.addEventListener('load', () => this.handleLoad())
  },
  handleLoad() {
    this.isLoaded = true
  },
  destroy() {
    this.img?.removeEventListener('load', this.handleLoad)
  },
}))
